<template>
    <!-- 学科定制服务 --> 
    <div class="home-region customization">
        <div class="region-cont">
            <div class="tit tit-gray" :class="customizationList.length>6?'margin-b8':''">学科定制服务 <div class="tit-bottom"></div></div>
            <p class="more" v-if="customizationList.length>6">查看更多<i class="el-icon-d-arrow-right"></i></p>
            <ul class="customization-list">
                <li class="list" v-for="(item,index) in customizationList" :key="index">
                    <a >
                        <p class="list-tit">{{item.tit}}</p>
                        <p class="list-cooperator">合作单位：{{item.cooperator}}</p>
                        <p class="list-txt">简介：{{item.txt}}</p>
                        <div class="list-more" @click="toPage(item,index+1)">了解更多</div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import homeData from '../homeData.js';
export default {
    data () {
        return {
            customizationList:homeData.customizationList
        }
    },
    methods: {
        toPage(item,sequence){ 
            if(item.href){
                this.$windowOpen({ url:item.href,isLogin:true} ) 
                return
            }
            let path='';
            let query={
                    sequence, 
                    changeflag:item.changeflag||7
                };
            if(item.sequence<=5){
                path='customizeInfo'; 
            }else if(item.sequence==7){
                path='customizeIframe'
                //跳到特色资源的检索页面=>resourceList
            }else if(item.sequence==6){ 
                path='resourceList'
                query.word='帕金森病（广东省中医院合作研发）'
                query.link='pd'
                //跳到特色资源的检索页面=>resourceList
            }
            else if(item.sequence==9){ 
                path='resourceList'
                query.word='赵炳南'
                query.link='zhaobingnan'
                //跳到特色资源的检索页面=>resourceList
            }
            let url= this.$router.resolve({
                    path,
                    query,
                }) 
            this.$windowOpen({ url:url.href,isLogin:true} ) 

        }
    }
}
</script>

<style lang="less" scoped>
.customization{
    min-width: 1200px;
    background: url('../../../assets/images/home/gray-page.png') no-repeat center;
    background-size: cover;
    .tit{
        width: 232px;
    }
    .margin-b8{
        margin-bottom: 8px;
    }
    .more{
        width: 80px;
        margin: 8px auto 30px;
        font-weight: bold;
        font-size: 16px;
        color: #386DE8;
        line-height: 30px;
        cursor: pointer;
    }
    .customization-list{
        margin-right:-20px ;
        display: flex;
        flex-wrap: wrap;
        .list{
            width: 388px;
            height: 196px;
            margin :0 0 18px 18px;
            a{
                color: #5A6779;
                background:#fff;// #F3F7FF;
                border-radius: 12px;
                padding:20px 30px;
                &:hover{
                    color: #2D3849;
                    background: linear-gradient( 180deg, #F3F7FF 0%, #E1EBFF 100%);
                    box-shadow: 0px 4px 12px -4px rgba(206,213,225,0.53);
                    .list-more{
                        color: #fff;
                        background: #386DE8;
                    }
                }
                
            }
            .list-tit{
                font-weight: bold;
                font-size: 20px; 
                line-height: 28px;
            }
            .list-cooperator{
                margin: 8px 0;
                line-height: 22px;
            }
            .list-txt{
                margin-bottom: 14px;
                height: 44px;
                line-height: 22px;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                display: -webkit-box;
                -webkit-line-clamp: 2;//（文字行数）;;
                -webkit-box-orient: vertical;  
            }
            .list-more{
                width: 96px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #dfe8f9;
                border-radius: 16px;
                color: #386DE8;
                cursor: pointer;
            }
        }
        
    }
}
</style>